import { GroupBase, StylesConfig, CSSObjectWithLabel } from 'react-select';
import { ISelectorOption } from 'types/ISelectorOption';
import { CSSObject } from '@emotion/serialize';

const languageStyle: Partial<
  Styles<ISelectorOption, boolean, GroupBase<ISelectorOption>>
> = {
  menu: (provided: any): CSSObjectWithLabel =>
    ({
      ...provided,
      width: '100%',
      backgroundColor: 'rgba(0, 0, 0, 1)',
      borderColor: 'rgba(255, 255, 255, 1)',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: '5px',
      marginTop: '1px',
    } as CSSObject),
  menuList: (provided: any): CSSObjectWithLabel =>
    ({
      ...provided,
      color: 'rgba(255, 255, 255, 1)',
      textAlign: 'center',
      overflow: 'hidden',
      cursor: 'pointer',
    } as CSSObject),
  singleValue: (provided: any): CSSObjectWithLabel =>
    ({
      ...provided,
      color: 'rgba(255,255,255,1)',
      textAlign: 'center',
      fontSize: '1.1rem',
    } as CSSObject),
  valueContainer: (provided: any): CSSObjectWithLabel => ({
    ...(provided as CSSObject),

    padding: '2px 0px',
    justifyContent: 'center',
  }),
  option: (state: any): CSSObjectWithLabel => {
    const defaultControlStyles: CSSObjectWithLabel = {
      width: '100%',
      boxSizing: 'border-box',
      padding: '5px 0px',
      fontSize: '1.1rem',
    };
    const focusedControlStyles: CSSObjectWithLabel = {
      backgroundColor: 'rgba(247, 148, 28, .3)',
      color: 'inherit',
      cursor: 'default',
      display: 'block',
      fontSize: 'inherit',
      padding: '8px 12px',
      width: '100%',
      userSelect: 'none',
      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
      boxSizing: 'border-box',
    };
    const selectedControlStyles: CSSObjectWithLabel = {
      backgroundColor: 'rgba(247,148, 28, .7)',
      color: 'inherit',
      cursor: 'default',
      display: 'block',
      fontSize: 'inherit',
      padding: '8px 12px',
      width: '100%',
      userSelect: 'none',
      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
      boxSizing: 'border-box',
    };

    if (state.isSelected) return selectedControlStyles;
    if (state.isFocused) return focusedControlStyles;

    return defaultControlStyles as CSSObject;
  },
  indicatorsContainer: (): CSSObjectWithLabel => ({
    backgroundColor: '#ea384d',
    margin: '3px',
    marginRight: '4px',
    borderRadius: 3,
    'div:nth-of-type(1n)': {
      color: '#FFF',
    },
  }),

  control: (state: any): CSSObjectWithLabel => {
    const defaultControlStyle: CSSObjectWithLabel = {
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0)',
      borderColor: 'rgba(255, 255, 255, 1)',
      borderRadius: 5,
      borderStyle: 'solid',
      borderWidth: 1,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minHeight: 47,
      outline: '0 !important',
      position: 'relative',
      transition: 'all 100ms',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 1)',
      },
      boxSizing: 'border-box',
      width: '100%',
      cursor: 'pointer',
    };

    const focusedControlStyles: CSSObjectWithLabel = {
      alignItems: 'center',
      backgroundColor: 'rgba(0, 0, 0, 1)',
      borderColor: 'rgba(255, 255, 255, 1)',
      borderRadius: 5,
      borderStyle: 'solid',
      borderWidth: 1,
      boxShadow: '0 0 10px rgba(247, 148, 28, .1)',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minHeight: 47,
      outline: '0 !important',
      position: 'relative',
      transition: 'all 100ms',
      boxSizing: 'border-box',
      width: '100%',
      cursor: 'pointer',
    };

    return state.isFocused ? focusedControlStyles : defaultControlStyle;
  },
};

export const errorStyles: Partial<
  Styles<ISelectorOption, boolean, GroupBase<ISelectorOption>>
> = {
  option: (provided, state) => languageStyle.option?.(provided, state) || {},
  control: () => {
    const controlHasErrorStyle: CSSObjectWithLabel = {
      alignItems: 'center',
      backgroundColor: 'hsl(0, 0%, 100%)',
      borderColor: '#ed4c78',
      borderRadius: 4,
      borderStyle: 'solid',
      borderWidth: 1,
      boxShadow: '0 0 10px rgba(247, 148, 28, .1)',
      cursor: 'default',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minHeight: 47,
      outline: '0 !important',
      position: 'relative',
      transition: 'all 100ms',
      boxSizing: 'border-box',
    };

    return controlHasErrorStyle;
  },
};

export default languageStyle;
